import { Outlet } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
// config
import { HEADER } from '../../config';
//
import MainHeader from './header';

// ----------------------------------------------------------------------

const MainStyle = styled('main', {
  shouldForwardProp: (prop) => prop !== 'collapseClick',
})(() => ({
  flexGrow: 1,
  paddingTop: HEADER.DASHBOARD_DESKTOP_HEIGHT,
  paddingBottom: 18,
}));

// ----------------------------------------------------------------------

export default function MainLayout() {
  return (
    <>
      <Box
        sx={{
          display: { lg: 'flex' },
          minHeight: 1,
          bgcolor: '#F5F5F5',
        }}
      >
        <MainHeader />

        <MainStyle>
          <Outlet />
        </MainStyle>
      </Box>
    </>
  );
}
